import React, { useCallback, useRef, useState } from 'react';
import { Upload } from 'lucide-react';

// One dropzone for every upload in the app. Callers own what happens to the
// files; this owns the drag state, the hidden input and the keyboard path.
export default function FileDropzone({
  accept,
  multiple = false,
  disabled = false,
  title,
  hint,
  children,
  onFiles,
}) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const emit = useCallback(
    (fileList) => {
      const files = Array.from(fileList || []);
      if (files.length) onFiles(multiple ? files : files[0]);
    },
    [multiple, onFiles]
  );

  const open = () => {
    if (!disabled) inputRef.current?.click();
  };

  return (
    <div
      className={`dropzone${dragging ? ' is-dragging' : ''}`}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      }}
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        if (!disabled) emit(e.dataTransfer.files);
      }}
    >
      <Upload size={28} />
      <div className="dropzone-title">{title}</div>
      {hint && <div className="dropzone-hint">{hint}</div>}
      {children}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        style={{ display: 'none' }}
        onChange={(e) => {
          emit(e.target.files);
          e.target.value = '';
        }}
      />
    </div>
  );
}
